import type { HTMLAttributes } from 'react';
import { cn } from '../cn.js';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  /** Raised surface with a stronger shadow. */
  elevated?: boolean;
  /** Adds press feedback + pointer cursor (use with onClick). */
  interactive?: boolean;
  /** Padding scale. Default 'md'. */
  padding?: 'none' | 'sm' | 'md' | 'lg';
}

/** A large, softly-rounded surface — the core building block of the UI. */
export function Card({
  elevated = false,
  interactive = false,
  padding = 'md',
  className,
  children,
  ...rest
}: CardProps): JSX.Element {
  return (
    <div
      className={cn(
        'as-card',
        elevated && 'as-card--elevated',
        interactive && 'as-card--interactive',
        `as-card--pad-${padding}`,
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}
